import { useEffect } from 'react';
import usePlansAPI from 'app/hooks/plans/usePlansAPI';
import useShieldSettingsAPI from 'app/hooks/shield/useShieldSettingsAPI';
import useUpdatePendo from 'app/hooks/pendo/useUpdatePendo';
import tracker from 'utils/dio/damage-protection';

function useDamageProtectionContainer() {
  // The Damage Protection feature toggle is set in the Guesty admin, not Split.io.
  // So, we use an API request instead of useFeatureToggle.
  const { isDamageProtectionEnabled, fetchIsDamageProtectionEnabled } =
    useShieldSettingsAPI();
  const { data, fetchCoveragePlan } = usePlansAPI();
  const { status, isDataLoaded } = data;

  useUpdatePendo({ status, isDamageProtectionEnabled });

  useEffect(() => {
    fetchIsDamageProtectionEnabled();
  }, [fetchIsDamageProtectionEnabled]);

  useEffect(() => {
    if (isDamageProtectionEnabled) {
      fetchCoveragePlan();
    }
  }, [isDamageProtectionEnabled]);

  const linkClickHandler = () => {
    tracker.onIconClick();
  };

  return {
    isDataLoaded,
    isDamageProtectionEnabled,
    onAnchorClick: linkClickHandler,
  };
}

export default useDamageProtectionContainer;
